import { styled } from 'leva/plugin';

export const NotificationContainer = styled('div', {
  position: 'fixed',
  left: '50%',
  bottom: '1rem',
  transform: 'translateX(-50%)',
  zIndex: 1005,
});
